import React from "react";
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import { Container, Wrapper } from "./style";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { navItems } from "../utils/navbar";
function App() {
  return (
    <Container>
      <Router>
        <Navbar />
        <Switch>
          <Wrapper>
            {navItems.map(({ path, component }) => {
              return <Route key={path} path={path} component={component} />;
            })}
            <Route exact path="/">
              <Redirect to="/home" />
            </Route>
          </Wrapper>
        </Switch>
        <Footer />
      </Router>
    </Container>
  );
}

export default App;
